import PropTypes from 'prop-types';

import { CircularProgress, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PortletContent = ({ children, noPadding, isLoading, sx, ...rest }) => {
  const theme = useTheme();
  const rootStyling = {
    paddingLeft: noPadding ? 0 : theme.spacing(3),
    paddingRight: noPadding ? 0 : theme.spacing(3),
    paddingTop: noPadding ? 0 : theme.spacing(2),
    paddingBottom: noPadding ? 0 : theme.spacing(2),
    flexGrow: 1,
  };

  if (isLoading) {
    return (
      <Box sx={{ padding: theme.spacing(3), display: 'flex', justifyContent: 'center' }}>
        <CircularProgress aria-label="Loading content" />
      </Box>
    );
  }

  return (
    <Box {...rest} sx={[rootStyling, ...(Array.isArray(sx) ? sx : [sx])].filter(Boolean)}>
      {children}
    </Box>
  );
};

PortletContent.propTypes = {
  children: PropTypes.node,
  noPadding: PropTypes.bool,
  isLoading: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};

PortletContent.defaultProps = {
  children: undefined,
  noPadding: true,
  sx: undefined,
};

export default PortletContent;
